export const RaceDetailsTable = ({ blocks = [] }) => {
  const rows = blocks.flatMap((block) =>
    block.rows.map((row) => ({
      block: block.title,
      ...row,
    }))
  );

  return (
    <div className="w-full">
      {/* Desktop Table (hidden on mobile, visible on md and up) */}
      <div className="hidden md:block bg-white rounded-2xl border border-slate-200 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full table-auto divide-y divide-slate-200">
            <thead>
              <tr className="bg-slate-50">
                <th className="px-6 py-4 text-left text-xs font-bold text-slate-500 uppercase tracking-wider">Blok</th>
                <th className="px-6 py-4 text-left text-xs font-bold text-slate-500 uppercase tracking-wider">Kategori</th>
                <th className="px-6 py-4 text-left text-xs font-bold text-slate-500 uppercase tracking-wider">Line</th>
                <th className="px-6 py-4 text-left text-xs font-bold text-slate-500 uppercase tracking-wider">Start</th>
                <th className="px-6 py-4 text-left text-xs font-bold text-slate-500 uppercase tracking-wider">COT</th>
                <th className="px-6 py-4 text-left text-xs font-bold text-slate-500 uppercase tracking-wider">Durasi</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200 bg-white">
              {rows.map((row) => (
                <tr key={`${row.block}-${row.category}`} className="hover:bg-slate-50 transition-colors">
                  <td className="px-6 py-4 text-sm font-medium text-slate-600 whitespace-nowrap">{row.block}</td>
                  <td className="px-6 py-4 text-sm font-bold text-slate-900 whitespace-nowrap">{row.category}</td>
                  <td className="px-6 py-4 text-sm text-slate-600 whitespace-nowrap">
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-slate-100 text-slate-700 border border-slate-200">
                      {row.line}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-sm text-slate-600 whitespace-nowrap">{row.start}</td>
                  <td className="px-6 py-4 text-sm text-slate-600 whitespace-nowrap">{row.cot}</td>
                  <td className="px-6 py-4 text-sm font-semibold text-red-600 whitespace-nowrap">{row.duration}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Mobile Card Layout (visible on mobile, hidden on md and up) */}
      <div className="md:hidden space-y-4">
        {blocks.map((block) => (
          <div key={block.title} className="bg-white rounded-2xl border border-slate-200 overflow-hidden">
            {/* Header of Block */}
            <div className="bg-slate-50 border-b border-slate-200 px-4 py-3">
              <h3 className="text-xs font-extrabold text-slate-700 uppercase tracking-wider">
                {block.title}
              </h3>
            </div>
            
            {/* Block Rows */}
            <div className="divide-y divide-slate-100">
              {block.rows.map((row) => (
                <div key={row.category} className="p-4 space-y-3">
                  {/* Category Header */}
                  <div className="flex items-center justify-between">
                    <span className="text-sm font-extrabold text-slate-900">{row.category}</span>
                    <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-bold bg-slate-100 text-slate-700 border border-slate-200">
                      {row.line}
                    </span>
                  </div>
                  
                  {/* Details Grid */}
                  <div className="grid grid-cols-3 gap-2 pt-1">
                    <div>
                      <p className="text-[9px] font-bold text-slate-400 uppercase tracking-wider">Start Time</p>
                      <p className="text-xs font-semibold text-slate-700 mt-0.5">{row.start}</p>
                    </div>
                    <div>
                      <p className="text-[9px] font-bold text-slate-400 uppercase tracking-wider">Cut Off Time</p>
                      <p className="text-xs font-semibold text-slate-700 mt-0.5">{row.cot}</p>
                    </div>
                    <div className="text-right">
                      <p className="text-[9px] font-bold text-slate-400 uppercase tracking-wider">Duration</p>
                      <p className="text-xs font-bold text-red-600 mt-0.5">{row.duration}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
